import { watch } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import {
   resolveTieneSeccion1,
   syncContextualLogoForRoute,
} from '@/helpers/contextualLogo';

export const useContextualLogo = () => {
   const route = useRoute();
   const store = useStore();

   watch(
      () => [
         route.path,
         store.state.auth.usuario?.id_empresa,
         store.state.auth.usuario?.id_grupo,
         store.state.main.sections,
      ],
      () => {
         const tieneSeccion1 = resolveTieneSeccion1(store.state.main.sections);
         // Sin `sections` no se puede elegir entre logo propio y Pilait:
         // esperamos a que carguen para no pedir primero el logo equivocado.
         if (tieneSeccion1 === undefined) {
            return;
         }
         const usuario = store.state.auth.usuario;
         syncContextualLogoForRoute(
            usuario?.id_empresa,
            route.path,
            usuario?.id_grupo,
            tieneSeccion1,
         );
      },
      { immediate: true },
   );
};
